import { Dispatch, SetStateAction, useRef } from "react";
import { Popover, Whisper } from "rsuite";
import { Button } from "reactstrap";

import DropdownOptionWithIcon from "../../../components/Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "../../../components/Menus/PopoverDropdownMenu";
import { LibraryViewType } from "../Library";

interface Props {
  setViewType: Dispatch<SetStateAction<LibraryViewType>>;
  viewType: LibraryViewType;
}

function LibraryLayoutSelector({ viewType, setViewType }: Props) {
  const layoutWhisperRef = useRef<any>();

  return (
    <Whisper
      placement="autoVertical"
      trigger="click"
      ref={layoutWhisperRef}
      preventOverflow
      speaker={
        <Popover className="sidebar-popover">
          <PopoverDropdownMenu>
            <DropdownOptionWithIcon
              name="List View"
              onClick={() => {
                setViewType("List");
                layoutWhisperRef.current.close();
              }}
              icon="mdi mdi-view-list-outline"
              active={viewType === "List"}
            />
            <DropdownOptionWithIcon
              name="Grid View"
              onClick={() => {
                setViewType("Grid");
                layoutWhisperRef.current.close();
              }}
              icon="mdi mdi-view-grid-outline"
              active={viewType === "Grid"}
            />
          </PopoverDropdownMenu>
        </Popover>
      }
    >
      <Button
        size="sm"
        color="secondary"
        className="tw:flex tw:justify-center tw:items-center tw:truncate"
      >
        {viewType === "List" ? (
          <>
            <i className="mdi mdi-view-list-outline"></i>
            <span className="ml-1">List</span>
            <i className="mdi mdi-chevron-down" style={{ fontSize: "20px" }} />
          </>
        ) : (
          <>
            <i className="mdi mdi-view-grid-outline"></i>
            <span className="ml-1">Grid</span>
            <i className="mdi mdi-chevron-down" style={{ fontSize: "20px" }} />
          </>
        )}
      </Button>
    </Whisper>
  );
}

export default LibraryLayoutSelector;
